<div class="searchModal">
  <!-- <button aria-label="close modal" class="vc-modal__closeBtn" [mat-dialog-close]> -->
  <!-- <span class="vc-modal__closeBtn__crossLeft"></span> -->
  <!-- <span class="vc-modal__closeBtn__crossRight"></span> -->
  <!-- </button> -->
  <div class="searchModal__contentContainer">
    <vc-searchbar-content (submitSearch)="closeDialog()" [parentLocation]="'modal'"></vc-searchbar-content>
    <button class="searchModal__backButton" (click)="leaveSearch()">
      <span class="searchModal__backButton__arrow"></span>
    </button>
  </div>
</div>
